import { Component } from 'react';
import { Api } from '../../api';
import envConfig from '../../configs/env-config';

interface Props {
  handleSignIn: any;
}

const api = new Api();
const GOOGLE_YOLO_CLIENT_ID = envConfig.GOOGLE_YOLO_CLIENT_ID;

class GoogleYolo extends Component<any, Props> {
  private async useGoogleIdTokenForAuth(idToken: string) {
    const data = {
      idToken,
      clientId: GOOGLE_YOLO_CLIENT_ID,
    };
    const authRes = await api.authenticateGoogleIdToken(data);
    if (authRes) {
      this.props.handleSignIn();
    }
  }

  private oneTapOrAutomaticSignIn(credential: object) {
    if (credential.credential) {
      this.useGoogleIdTokenForAuth(credential.credential);
    }
  }

  public componentDidMount() {
    // to open the acc selection prompt
    window.onGoogleLibraryLoad = () => {
      google.accounts.id.initialize({
        client_id: GOOGLE_YOLO_CLIENT_ID,
        auto_select: false,
        callback: this.oneTapOrAutomaticSignIn.bind(this),
      });
      google.accounts.id.prompt();
    };
  }

  public render() {
    return null;
  }
}

export default GoogleYolo;



// WEBPACK FOOTER //
// ./components/common/googleYolo.tsx